<template>
    
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
            <div class="content">
                <section class="section--sidebar-user">
                    
                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data" class="workflow-tabs">
                            <input type="hidden" name="_token" :value="csrf">
                            <input v-if="this.editing" type="hidden" name="_method" value="PUT">
                            <div class="tab-content">
                                
                                <div class="row mb-3">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.title")}}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[name]" :value="this.name">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.description")}}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[description]" :value="this.description">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.sorting")}}</label>
                                            <input type="number" class="form-control rounded" name="questionBase[sorting]" :value="this.sorting">
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row mb-3">
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label>Pick a question</label>
                                            <select class="form-control rounded" ref="headerStandardElement" :v-model="newStandardElement" @change="insertStandardElement($event)">
                                                <option value="-"></option>
                                                <optgroup label="Valutazione">
                                                    <option value="session">{{ __("forms.questionsLabel.session") }}</option>
                                                    <option value="evaluated">{{__("forms.questionsLabel.evaluated")}}</option>
                                                    <option value="person_code">{{__("forms.Person.person_code")}}</option>
                                                    <option value="person_tax_code">{{__("forms.questionsLabel.person_tax_code")}}</option>
                                                    <option value="evaluator">{{__("forms.questionsLabel.evaluator")}}</option>
                                                    <option value="responsible">{{__("forms.questionsLabel.responsible")}}</option>
                                                    <option value="evaluator_tax_code">{{__("forms.questionsLabel.evaluator_tax_code")}}</option>
                                                    <option value="badge">{{__("forms.questionsLabel.badge")}}</option>
                                                    <option value="hired_at">{{__("forms.questionsLabel.hired_at")}}</option>
                                                    <option value="resigned_at">{{__("forms.questionsLabel.resigned_at")}}</option>
                                                    <option value="seniority">{{__("forms.questionsLabel.seniority")}}</option>
                                                    <option value="seniority_first_hired_at">{{__("forms.questionsLabel.first_hired_at")}}</option>
                                                    <option value="seniority_role">{{__("forms.questionsLabel.seniority_role")}}</option>
                                                    <option value="role">{{__("forms.questionsLabel.role")}}</option>
                                                    <option value="template">{{__("forms.questionsLabel.template")}}</option>
                                                    <option value="role_on_chart">{{__("forms.questionsLabel.role_on_chart")}}</option>
                                                    <option value="pay_item">{{__("forms.questionsLabel.pay_item")}}</option>
                                                    <option value="contractual_item">{{__("forms.questionsLabel.contractual_item")}}</option>
                                                </optgroup>
                                                <optgroup label="Colloquio Candidato">
                                                    <option value="candidated_at">{{__("forms.questionsLabel.candidated_at")}}</option>
                                                    <option value="role_candidature">{{__("forms.questionsLabel.role_candidature")}}</option>
                                                    <option value="candidated">{{__("forms.questionsLabel.candidated")}}</option>
                                                    <option value="age">{{__("forms.questionsLabel.age")}}</option>
                                                </optgroup>
                                                <optgroup label="Extra">   
                                                    <option value="alias_username">{{__("forms.People.alias_username")}}</option>
                                                    <option value="alias_email">{{__("forms.People.alias_email")}}</option>
                                                    <option value="role_signature">{{__("forms.questionsLabel.role_signature")}}</option>
                                                    <option value="person_typology">{{__("forms.People.typology_id")}}</option>
                                                    <option value="person_code">{{__("forms.People.person_code")}}</option>
                                                    <option value="base_chart">{{__("forms.questionsLabel.base_chart")}}</option>
                                                    <option value="headquarter">{{__("forms.questionsLabel.headquarter")}}</option>
                                                    <option value="company">{{__("forms.questionsLabel.company")}}</option>
                                                    <option value="organizational_unit_type">{{__("forms.questionsLabel.organizational_unit_type")}}</option>
                                                </optgroup>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- headings -->
                                <div class="row">
                                    <div class="col-4">Element</div>
                                    <div class="col-4">Other info</div>
                                    <div class="col-4"></div>
                                </div>
                                
                                <!-- entries -->
                                <div class="row align-items-center mb-1" v-for="(row, indexR) in elements" :key="indexR">
                                    <input type="hidden" :name="'questionSettings['+indexR+']'" :value=row>
                                    <div class="col-4">
                                        <h6>{{__("forms.questionsLabel."+row)}}</h6>
                                    </div>
                                    <div class="col-4">
                                        <select class="form-control rounded" v-if="row.includes('contractual_item')" required :name="'questionExtraSetting['+indexR+']'" v-model="settings[indexR]">
                                            <option></option>
                                            <option v-for="(label,index) in extraElements.contr" :value="index" :key="index">
                                                {{label}}
                                            </option>
                                        </select>
                                        <select class="form-control rounded" v-else-if=" row.includes('organizational_unit')" required :name="'questionExtraSetting['+indexR+']'" v-model="settings[indexR]" >
                                            <option></option>
                                            <option v-for="(label,index) in extraElements.organizational_unit_type" :value="index" :key="index">
                                                {{label}}
                                            </option>
                                        </select>
                                        <select class="form-control rounded" v-else-if=" row.includes('pay_item')" required :name="'questionExtraSetting['+indexR+']'" v-model="settings[indexR]" >
                                            <option></option>
                                            <option v-for="(label,index) in extraElements.retr" :value="index" :key="index">
                                                {{label}}
                                            </option>
                                        </select>
                                        <span v-else>---</span>
                                        
                                    </div>
                                    <div class="col-4 text-right">
                                        <button type="button" class="btn btn--only-icon-rounded btn--danger float-right" @click="popElement(indexR)" ><i class="fas fa-times"></i></button>
                                    </div>
                                </div>
                                
                                
                                <div class="row">
                                        <div class="col-12">
                                            <hr>
                                        </div>
                                        <div class="col-12 mt-3 text-right" v-if="can_write">
                                            <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                                        </div>
                                    </div>
                                
                            </div>
                        </form>
                    </section>
                </section>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {
    
    props: {
        can_write:{
            type:Boolean,
            required:true,
        }
    },
    data () {
        return {
            
            newStandardElement      : '-',
            newExtraElement         : '-',
            elements : [],
            extraElements : [],
            settings : [],
            //default
            title       : "Header",
            active      : false,
            action      : "",
            name        : "",
            description : "",
            sorting     : -1,
            editing     : true,
            csrf        : document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    methods: {
        popElement(index){
            this.elements.splice(index, 1)
        },
        insertStandardElement(event){
            
            if(event.target.value === '-'){
                return;
            }
            if (event.target.value !== 'pay_item' && event.target.value !== 'contractual_item' && event.target.value !== 'organizational_unit_type' && this.elements.includes(event.target.value)){
                alert("Elemento gia inserito");
            }else{
                this.elements.push(event.target.value);
            }
            this.newStandardElement = "-";
        },
        
        toggle(action, item_id, editing, attributes) {
            this.active     = true;
            this.action     = action;
            this.editing    = editing;
            this.lang       = attributes.lang;
            
            let dataRoute   = decodeURI(attributes.dataRoute);
            if (dataRoute!==undefined) {
                if (dataRoute.indexOf("[id]")>0) {
                    dataRoute = dataRoute.replace("[id]", item_id);
                    
                }
                axios.get(dataRoute)
                .then((response) => {
                    this.name = response.data.base.name;
                    this.description = response.data.base.description;
                    this.sorting = response.data.base.sorting;
                    this.elements = response.data.elements;
                    this.settings = response.data.settings;
                    this.can_write = app.__vue__.questionPermission(this.can_write,response.data.base.enable);                           
                });
                axios.get("/questions-survey-extra-header-voices")
                .then((response) => {
                    this.extraElements = response.data;
                });
            }
        }
        
    }
    
}
</script>

